import { JSX } from "react";

export function Dashboard(): JSX.Element {
  return <div>Dashboard</div>;
}
